import { FormDataContext, KindContext, SaveContext } from "../kinds/types";
import { ObjectDetailsStore } from "../model/details";
import { ObjectServicesStore } from "../model/objectServices";
import { ReferencesStore } from "../model/references";
import { TreeStore } from "../model/tree";

/**
 * Сборка окружений для обработчиков вариантов.
 *
 * Обработчику дают ровно то, что он спрашивает: чтение дерева, готовые детали
 * и, где нужно, справочники. Ни стора, ни фасада он не видит.
 */
export const kindContextOf = (
  tree: TreeStore,
  details: ObjectDetailsStore,
  services: ObjectServicesStore,
): KindContext => ({
  node: (id) => tree.node(id),
  ownerObject: (id) => tree.ownerObject(id),
  details: (objectId) => details.peek(objectId),
  states: (objectId) => services.statesOf(objectId),
});

export const formDataContextOf = (
  tree: TreeStore,
  details: ObjectDetailsStore,
  services: ObjectServicesStore,
  references: ReferencesStore,
): FormDataContext => ({
  ...kindContextOf(tree, details, services),
  get roleGroups() {
    return references.roleGroups;
  },
  get attrTypeActions() {
    return references.attrTypeActions;
  },
});

export const saveContextOf = (
  tree: TreeStore,
  details: ObjectDetailsStore,
  services: ObjectServicesStore,
  references: ReferencesStore,
): SaveContext => ({
  ...kindContextOf(tree, details, services),
  get attrTypesDict() {
    return references.attrTypesDict;
  },
});
